// src/pages/Home.js

import React from 'react';
import './Home.css';

// Import the 3D Brain component
import Brain from '../components/Brain'; 

// Import your logo image
import logoImage from '../assets/logo_golden.png';

// Import your icon images
import innovateIcon from '../assets/innovate-icon.png';
import connectIcon from '../assets/connect-icon.png';
import secureIcon from '../assets/secure-icon.png';
import collaborateIcon from '../assets/collaborate-icon.png';

const Home = () => {
  return (
    <div className="home-page-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="brain-canvas-container">
          <Brain />
        </div>
        
        {/* 1. The "Welcome to" text is now alone in the h1 tag */}
        <h1 className="hero-title">
          Welcome to
        </h1>
        
        {/* 2. The logo is a separate image tag below the h1, with a new class name */}
        <img src={logoImage} alt="Govindam" className="main-logo-image" />

        <p className="hero-subtitle">
          A divine digital experience. Crafted with modern technology, inspired by timeless tradition.
        </p>
      </section>

      {/* Features/Icons Section (remains the same) */}
      <section className="features-section">
        {/* ... your feature items ... */}
        <div className="feature-item">
          <img src={innovateIcon} alt="Innovate" className="feature-icon" />
          <span className="feature-label">INNOVATE</span>
        </div>
        <div className="feature-item">
          <img src={connectIcon} alt="Connect" className="feature-icon" />
          <span className="feature-label">CONNECT</span>
        </div>
        <div className="feature-item">
          <img src={secureIcon} alt="Secure" className="feature-icon" />
          <span className="feature-label">SECURE</span>
        </div>
        <div className="feature-item">
          <img src={collaborateIcon} alt="Collaborate" className="feature-icon" />
          <span className="feature-label">COLLABORATE</span>
        </div>
      </section>
    </div>
  );
};

export default Home;